import Marquee from "react-fast-marquee";
import { Droplet } from "lucide-react";
import { marqueeItems } from "@/data/content";

export default function ServiceMarquee() {
  return (
    <div className="bg-pristine-blue py-5 border-y border-white/10" data-testid="service-marquee">
      <Marquee speed={30} gradient={false} autoFill>
        {marqueeItems.map((item, i) => (
          <div key={i} className="flex items-center gap-4 mx-8">
            <Droplet className="h-4 w-4 text-pristine-aquamid" fill="rgba(178,235,242,0.3)" />
            <span className="font-heading text-lg sm:text-xl font-light text-white/90 tracking-wide">
              {item}
            </span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
